

































import { Component, Mixins } from "vue-property-decorator";
import ExpansionPanel from "@/components/ui/ExpansionPanel.vue";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import ReportItem from "@/components/reports/SingleParamReport.vue";
import ReportItemPay from "@/components/reports/SingleParamReportPay.vue";
import ReportItemUnwrapped from "@/components/reports/SingleReportUnwrapped.vue";
import ReportItemUnwrapped1 from "@/components/reports/SingleReportUnwrapped1.vue";
import ReconciliationReport from "@/components/reports/ReconciliationReport.vue";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import ElectricityReport from "@/components/reports/ElectricityReport.vue";
import NotificationPowerConsumption from "@/components/reports/NotificationPowerConsumption.vue";

@Component({
  components: {
    ExpansionPanel,
    MonthPicker,
    ReportItem,
    ReportItemUnwrapped,
    ReportItemUnwrapped1,
    ReconciliationReport,
    ReportItemPay,
    ElectricityReport,
    NotificationPowerConsumption,
  },
})
export default class ReportFormsViews extends Mixins(ContractIdValidatorMixin) {
  // get reports() {
  //   return [
  //     {
  //       path: "InvoiceAct.prpt",
  //       title: this.$t("reportsInfo.invoice-act.title"),
  //     },
  //     {
  //       path:
  //         this.$i18n.locale === "ru"
  //           ? "InvoiceBill.prpt"
  //           : "InvoiceBillKZ.prpt",
  //       title: this.$t("reportsInfo.invoice-bill.title"),
  //     },
  //   ];
  // }

  async mounted() {
    await this.validateContractId();
  }
}
